import Vue from 'vue'
import { getApiHost } from "./getApiHost.js";
import { logEvent, getCloudData } from "../apis/serviceApi.js";
import Fingerprint2 from "fingerprintjs2";
import { customErrorReport, getMonitorInstance } from '@/utils/monitor'
import { getUserInfo } from "./userInfo.js";
// 判断是否是Android
const isAndroid = () => {
  var info = getBrowerInfo();
  if (info.versions.android) {
    return true;
  }
  return false;
};
// 判断是否是ios
const isIOS = () => {
  var info = getBrowerInfo();
  if (info.versions.ios) {
    return true;
  }
  return false;
};
const getHost = () => {
  return new Promise((resolve, reject) => {
    resolve(getApiHost());
  });
};
// 深拷贝
const objDeepCopy = (source) => {
  var sourceCopy = source instanceof Array ? [] : {};
  for (var item in source) {
    sourceCopy[item] =
      typeof source[item] === "object" && source[item] !== null
        ? objDeepCopy(source[item])
        : source[item];
  }
  return sourceCopy;
};
const handleBuryPoint = async(pageId, clickid, ext = {}) => {
  const { tenantId } = getUserInfo() || {};
  // 浏览器
  ext.useragent = window.navigator.userAgent;
  ext = JSON.stringify(ext);
  // 用户id
  const params = {
    commonParams: {
      domainType: 200,
      terminal: 301
    },
    userId: null,
    channel: 'h5-designated-recruit',
    tenantId: tenantId || getQuery()?.tenantId,
    events: [
      {
        page: pageId,
        click: clickid,
        time: Date.now(),
        ext: ext,
      }
    ]
  };
  logEvent(params);
};
// 使用高德
const getLocalCity = () => {
  return new Promise((resolve, reject) => {
    amapGeolocation()
      .then((res) => {
        resolve(res);
      })
      .catch(() => {
        reject({ msg: "定位失败" });
      });
  });
};
const map = new window.AMap.Map("container");
// 使用精准定位获取定位信息
const amapGeolocation = () => {
  return new Promise((resolve, reject) => {
    map.plugin(["AMap.Geolocation", "AMap.CitySearch"], function (params) {
      var geolocation = new window.AMap.Geolocation();
      geolocation.getCurrentPosition(function (status, result) {
        if (status === "complete" && result && result.addressComponent) {
          resolve({
            adcode: result.addressComponent.adcode,
            city:
              result.addressComponent.city || result.addressComponent.province,
            province: result.addressComponent.province,
            lon: result.position.lng,
            lat: result.position.lat,
          });
        } else {
          resolve();
        }
      });
    });
  });
};
const aMapCitySearch = () => {
  return new Promise((resolve, reject) => {
    map.plugin(["AMap.Geolocation", "AMap.CitySearch"], function (params) {
      var citySearch = new window.AMap.CitySearch();
      citySearch.getLocalCity(function (status, result) {
        if (status === "complete" && result.info === "OK") {
          // 查询成功，result即为当前所在城市信息
          result.adCode = result.adcode; // 为了兼容不同版本需求。设置两个
          resolve(result);
        } else {
          reject({ msg: "定位失败" });
        }
      });
    });
  });
};
// 获取浏览器信息
const getBrowerInfo = () => {
  return {
    versions: (function () {
      const u = navigator.userAgent;
      return {
        trident: u.includes("Trident"), // IE内核
        presto: u.includes("Presto"), // opera内核
        webKit: u.includes("AppleWebKit"), // 苹果、谷歌内核
        gecko: u.includes("Gecko") && !u.includes("KHTML"), // 火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
        android: u.includes("Android") || u.includes("Adr"), // android终端
        iPhone: u.includes("iPhone"), // 是否为iPhone或者QQHD浏览器
        iPad: u.includes("iPad"), // 是否iPad
        webApp: !u.includes("Safari"), // 是否web应该程序，没有头部与底部
        weixin: u.includes("MicroMessenger"), // 是否微信 （2015-01-22新增）
        qq: u.match(/\sQQ/i) === " qq", // 是否QQ
        innerAmap: u.includes('YYApp'), // 是否是在代驾app 中
        dingTalk: u.includes("DingTalk"), // 是否在钉钉中
      };
    })(),
    language: (navigator.browserLanguage || navigator.language).toLowerCase(),
  };
};
const getQuery = () => {
  const result = {};
  const url = window.location.href;
  const reg1 = /([^?=&#]+)=([^?=&#]+)/g;
  const reg2 = /#([^?=&#]+)/g;
  url.replace(reg1, (n, x, y) => (result[x] = y));
  url.replace(reg2, (n, x) => (result["HASH"] = x));
  return result;
};

// 是否在端内
const isInnerYueyue = () => {
  const query = getQuery();
  if (query.isInnerApp && +query.isInnerApp === 1) {
    return true;
  }
  const info = getBrowerInfo();
  if (info.versions.innerAmap) {
    return true;
  }
  return false;
};
// 是否端内招募
const isInnerAppRecruit = () => {
  return true;
};
const getFingerPrint = () => {
  return new Promise((resolve, reject) => {
    if (window.requestIdleCallback) {
      requestIdleCallback(function () {
        Fingerprint2.get(function (components) {
          var values = components.map(function (component) {
            return component.value;
          });
          var murmur = Fingerprint2.x64hash128(values.join(""), 31);
          resolve(murmur); // an array of components: {key: ..., value: ...}
        });
        // resolve(Fingerprint2.x64hash128())
      });
    } else {
      setTimeout(function () {
        // resolve(Fingerprint2.x64hash128())
        Fingerprint2.get(function (components) {
          var values = components.map(function (component) {
            return component.value;
          });
          var murmur = Fingerprint2.x64hash128(values.join(""), 31);
          resolve(murmur); // an array of components: {key: ..., value: ...}
        });
      }, 500);
    }
  });
};
const buryPointBase = (tenantId, pageId, clickid, ext) => {
  const mobile = sessionStorage.getItem("cacheMobile") || "";
  const adCode = sessionStorage.getItem("pointAdcode") || "";
  const ua = isIOS() ? "ios" : "android";
  ext.ua = ua;
  handleBuryPoint(pageId, clickid, ext);
};
const buryPoint = (tenantId, pageId, clickid, ext) => {
  ext.userAgent = isInnerYueyue() ? "innerAmap" : "outAmap";
  let FingerPrintAndTimestamp = localStorage.getItem("FingerPrintAndTimestamp");
  // 使用屏幕指纹外接 时间戳作为用户标标志 如果已经有缓存了就不在获取
  if (FingerPrintAndTimestamp) {
    ext.browerFingerPrint = FingerPrintAndTimestamp;
    buryPointBase(tenantId, pageId, clickid, ext);
  } else {
    getFingerPrint()
      .then((FingerPrint) => {
        FingerPrintAndTimestamp = FingerPrint + Date.now();
        if (pageId == "recruiting-TheLogin") {
          clickid = "recruiting-TheLogin_UV";
        } else if (pageId == "customerRentedList") {
          clickid = "customerRentedList_UV";
        }
        localStorage.setItem(
          "FingerPrintAndTimestamp",
          FingerPrintAndTimestamp
        );
        ext.browerFingerPrint = FingerPrintAndTimestamp;
        buryPointBase(tenantId, pageId, clickid, ext);
      })
      .catch(() => {});
  }
};

function setCSP(cspPolicy) {
  // 查找是否已经存在 upgrade-insecure-requests meta 标签
  let upgradeMeta = document.querySelector(
    "meta[http-equiv='Content-Security-Policy'][content='upgrade-insecure-requests']"
  );
  if (!upgradeMeta) {
    // 如果没有 upgrade-insecure-requests meta 标签，创建并添加一个新的
    upgradeMeta = document.createElement("meta");
    upgradeMeta.setAttribute("http-equiv", "Content-Security-Policy");
    upgradeMeta.setAttribute("content", "upgrade-insecure-requests");
    document.head.appendChild(upgradeMeta);
  }
  // 查找是否已经存在 CSP meta 标签（content 包含 default-src）
  let cspMeta = document.querySelector(
    "meta[http-equiv='Content-Security-Policy'][content*='default-src']"
  );
  if (cspMeta) {
    // 如果已有 CSP meta 标签，更新其 content 属性
    cspMeta.setAttribute("content", cspPolicy);
  } else {
    // 如果没有 CSP meta 标签，创建并添加一个新的
    cspMeta = document.createElement("meta");
    cspMeta.setAttribute("http-equiv", "Content-Security-Policy");
    cspMeta.setAttribute("content", cspPolicy);
    document.head.appendChild(cspMeta);
  }
}

function removeCSP() {
  // 查找并移除 upgrade-insecure-requests meta 标签
  let upgradeMeta = document.querySelector(
    "meta[http-equiv='Content-Security-Policy'][content='upgrade-insecure-requests']"
  );
  if (upgradeMeta) {
    upgradeMeta.parentNode.removeChild(upgradeMeta);
  }

  // 查找并移除 CSP meta 标签
  let cspMeta = document.querySelector(
    "meta[http-equiv='Content-Security-Policy'][content*='default-src']"
  );
  if (cspMeta) {
    cspMeta.parentNode.removeChild(cspMeta);
  }
}

function isLocalhostOrIp(url) {
  // 如果 URL 没有协议部分，默认加上 http://
  try {
    const { hostname, port } = new URL(url);
    const localhostPattern = /^(localhost|127\.0\.0\.1)$/;
    const ipv4Pattern =
      /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(:\d+)?$/;
    // 如果是 localhost 或者 IP 地址，并且包含端口号，则返回 true
    return (
      (localhostPattern.test(hostname) || ipv4Pattern.test(hostname)) &&
      port !== ""
    );
  } catch (e) {
    // 如果 URL 解析失败，说明它不合法
    return false;
  }
}

// 是否 测网
const isTest = () => {
  const host = window.location.host;
  return !host || host.includes('localhost') || host.indexOf('test') !== -1 || /^[0-9.:]+$/.test(host);
};

// 设置cookie
const setCookie = (name, value, domain, expireDate) => {
  const exDate = new Date();
  exDate.setDate(exDate.getDate() + expireDate);
  document.cookie =
    name +
    '=' +
    decodeURIComponent(value) +
    (expireDate == null ? '' : ';expires=' + exDate.toUTCString()) +
    ';path=/;domain=' +
    domain;
}

// 删除某个cookie
const deleteCookie = (name, path, domain) => {
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT" +
    (path ? "; path=" + path : "") +
    (domain ? "; domain=" + domain : "");
}

// 监控-上报接口异常
const interErrorMonitor = ({name, msg}) => {
  try {
    customErrorReport({
      name: 'warning',
      msg,
      errorType: 'monitor',
      level: 'error'
    })
  }catch(e) {
    let catchMsg = ''
    if(typeof e === 'string') {
      catchMsg = e
    } else if(typeof e === 'object') {
      catchMsg = e.message || ''
    }
    handleBuryPoint('InterErrorMonitor', 'h5-designated-recruitFunctionError', {catchMsg})
  }
}

// 初始化系统配置 CSP、monitor等
const initSysConfig = async () => {
  const { code, data } = await getCloudData({
    group: 'designate-passenger',
    moduleName: 'unicornStaticConfig',
    configName: 'h5BaseSwitchConfig',
    tenantId: 999
  });
  if (code === 1) {
    try {
      // h5基础开关云控 csp、monitor
      const h5baseSwitchjson = JSON.parse(data.values.h5BaseSwitchConfig);
      const projectName = 'h5-designated-recruit';
      if (h5baseSwitchjson[projectName]?.csp === true) {
        handleInitCSP();
      } else {
        removeCSP();
      }
      if (h5baseSwitchjson[projectName]?.monitor === true) {
        initMonitor();
      }
    } catch (err) {
      removeCSP();
    }
  } else {
    removeCSP();
  }
};

const handleInitCSP = () => {
  const str =
    "default-src *; img-src data: https:; script-src 'self' 'unsafe-inline' 'unsafe-eval' https://*.longjudj.com https://*.yueyuechuxing.cn https://*.amap.com https://*.qq.com https://unpkg.com; style-src 'self' 'unsafe-inline'; connect-src https://*.yueyuechuxing.cn https://*.longjudj.com https://*.amap.com; worker-src blob:; font-src data: https:; frame-src 'self' wvjbscheme: https:;";
  if (isLocalhostOrIp(window.location.href)) {
    removeCSP();
    return;
  }
  setCSP(str);
};

const initMonitor = () => {
  getMonitorInstance({
    category: 'dj',
    appnm: 'dj-driver',
    project: 'h5-designated-recruit',
    systemName: '代驾司机招募',
    Vue
  });
};

export {
  getHost,
  handleBuryPoint,
  getLocalCity,
  isInnerYueyue,
  isInnerAppRecruit,
  objDeepCopy,
  buryPoint,
  getQuery,
  isAndroid,
  isIOS,
  isTest,
  setCookie,
  deleteCookie,
  initSysConfig
};
